import { styled } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";

import theme from "../../constants/theme";

export default styled(DeleteIcon)({
  color: "#fff",
  backgroundColor: theme.palette.primary.main,
  padding: theme.spacing(1),
  borderRadius: 4,
  marginRight: theme.spacing(1),
  cursor: "pointer",
  [theme.breakpoints.only("xs")]: {
    fontSize: 14,
    padding: theme.spacing(0.5),
  },
});
